import React from "react";
import Image from "next/image";
import {
  Qualifications,
  QualificationCard,
  QualificationSections
} from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData } from "@storyblok/react";

interface QualificationsProps {
  blok: Qualifications & SbBlokData;
}

const QualificationsComponent: React.FC<QualificationsProps> = ({ blok }) => {
  const { title, text, body: sections = [] } = blok;

  const renderScrollingLogos = (
    qualifications: QualificationCard[] = [],
    isReverse: boolean = false
  ) => (
    <div
      className={`mx-auto justify-content-start align-items-center g-4 horizontal-scrolling ${
        isReverse ? "horizontal-scrolling-reverse" : ""
      }`}
    >
      <div className="horizontal-scrolling-inner d-flex">
        {qualifications.map((item) => (
          <div
            key={item._uid}
            className="col-auto mb-3 mb-lg-4 card rounded-3 border-0 shadow p-2 me-4"
          >
            <Image
              src={item.image?.filename || ""}
              alt={item.alt_image || "Qualification logo"}
              width={300}
              height={300}
              className="img-fluid"
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              loading="lazy"
              quality={75}
            />
          </div>
        ))}
      </div>
    </div>
  );

  const renderQualificationSections = (
    sections: QualificationSections[] = []
  ) =>
    sections.map((section) => (
      <div key={section._uid} className="mb-5">
        {renderScrollingLogos(section.qualifications, section.is_reverse)}
      </div>
    ));

  return (
    <div className="section-qualifications bg-light py-4 py-md-5">
      {title && (
        <div className="container text-center my-2 my-md-3">
          <h2 className="text-center text-primary mb-4">{title}</h2>
          {text && <p className="lead mb-5 pb-3">{text}</p>}
        </div>
      )}

      {renderQualificationSections(sections)}
    </div>
  );
};

export default QualificationsComponent;